import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PatientRegistrationService {

  private apiUrl: string;
  
  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization' : `Bearer ${token}`
      })
    }
  }

  getPatient(pagination?: {
    page?: number;
    per_page?: number;
    search?: string;
    status?: string;
    mode?: string;
  }) {
    let params = new HttpParams();
    if (pagination?.page && Number(pagination.page) > 0) {
      params = params.set('page', String(pagination.page));
    }
    if (pagination?.per_page && Number(pagination.per_page) > 0) {
      params = params.set('per_page', String(pagination.per_page));
    }

    const trimmedSearch = pagination?.search?.trim() ?? '';
    if (trimmedSearch) {
      params = params.set('search', trimmedSearch);
    }

    const status = pagination?.status?.trim().toLowerCase() ?? 'all';
    if (status && status !== 'all') {
      params = params.set('status', status);
    }

    const mode = pagination?.mode?.trim().toLowerCase() ?? 'all';
    if (mode && mode !== 'all') {
      params = params.set('mode', mode.toUpperCase());
    }

    return this.http.get(
      // this.common.getBaseUrl() + 'patient');
      this.apiUrl + '/patient',
      {
        ...this.getAuthHeaders(),
        params
      }
    );
  }

  getSinglePatient(id: number) {
    return this.http.get(
      // this.common.getBaseUrl() + 'patient');
      this.apiUrl + '/patient/' + id,
      this.getAuthHeaders()
    );
  }

  getPatientsBatch(ids: number[]) {
    return this.http.post(this.apiUrl + '/patients/batch', { ids }, this.getAuthHeaders());
  }

  addPatient(payload: any) {
    // return this.http.post('/api/destinations', destination);
    // payload["action"] = "addPatient";
    // return this.http.post(this.common.getBaseUrl() + 'PRegistation.php', payload);
    return this.http.post(this.apiUrl + '/patient', payload,
      this.getAuthHeaders()
    );
  }

  updatePatient(payload: any) {
    payload["action"] = "updatePatient";
    // return this.http.put(this.common.getBaseUrl() + 'PRegistation.php', payload);
    return this.http.put(
      this.apiUrl + '/patient/' + payload.id, payload,
      this.getAuthHeaders()
    );
  }

  deletePatient(payload: any) {
    payload["action"] = "deletePatient";
    return this.http.delete(
      this.apiUrl + '/patient/' + payload.id, this.getAuthHeaders()
    );
  }

  toggleActive(id: number) {
    return this.http.patch(
      this.apiUrl + '/patient/' + id + '/toggle-active', {},
      this.getAuthHeaders()
    );
  }

  getPaymentHistory(payload: any) {
    return this.http.post(
      this.apiUrl + '/patient/payment-history', payload,
      this.getAuthHeaders()
    );
  }

  settleDues(payload: any) {
    return this.http.post(this.apiUrl + '/settle-dues', payload, this.getAuthHeaders())
  }

  getCards() {
    return this.http.get(
      // this.common.getBaseUrl() + 'patient');
      this.apiUrl + '/card',
      this.getAuthHeaders()
    );
  }

  getDuesData() {
    return this.http.get(
      this.apiUrl + '/reception/notifications',
      this.getAuthHeaders()
    );
  }

  getDuesNotification() {
    return this.http.post(
      this.apiUrl + '/reception/generate-due-notifications',
      this.getAuthHeaders()
    );
  }

  getPendingRegistrations(
    status: string = 'pending',
    page = 1,
    perPage = 25,
    search = ''
  ) {
    let params = new HttpParams()
      .set('status', status)
      .set('page', String(page))
      .set('per_page', String(perPage));

    const trimmedSearch = search.trim();
    if (trimmedSearch) {
      params = params.set('search', trimmedSearch);
    }

    return this.http.get(
      this.apiUrl + '/pending-patient-registrations',
      { ...this.getAuthHeaders(), params }
    );
  }

  approvePendingRegistration(id: number) {
    return this.http.post(
      this.apiUrl + '/pending-patient-registrations/' + id + '/approve',
      {},
      this.getAuthHeaders()
    );
  }

  rejectPendingRegistration(id: number, rejection_reason?: string) {
    return this.http.post(
      this.apiUrl + '/pending-patient-registrations/' + id + '/reject',
      { rejection_reason },
      this.getAuthHeaders()
    );
  }
}
